import DragBox from 'ol/interaction/DragBox';
import { fromExtent as polygonFromExtent } from 'ol/geom/Polygon';
import LinearRing from 'ol/geom/LinearRing';

export class AsyncRectangleSelectionInteraction extends DragBox {

  #startPolygonCoords;
  #isInProgress;

  constructor () {
    super({
      boxEndCondition: () => true // Override boxEndCondition to always dispatch the boxEnd event
    });
    this.setActive(false);

    this.on('change:active', event => {
      if (!event.oldValue) {
        this.onActivation();
      } else {
        this.onDeactivation();
      }
    });

    this._onBoxStartHandler = event => this._onBoxStart(event);
    this._onBoxEndHandler = event => this._onBoxEnd(event);
  }

  /**
   * Executed when the interaction is activated.
   * Can be overridden
   *
   * @protected
   */
  onActivation () {
    this.on('boxstart', this._onBoxStartHandler);
    this.on('boxend', this._onBoxEndHandler);
  }

  /**
   * Executed when the interaction is deactivated.
   * Can be overridden
   *
   * @protected
   */
  onDeactivation () {
    this.un('boxstart', this._onBoxStartHandler);
    this.un('boxend', this._onBoxEndHandler);
  }

  _onBoxStart (event) {
    this.#startPolygonCoords = event.coordinate;
  }

  _onBoxEnd (event) {
    const geometry = polygonFromExtent(new LinearRing([ this.#startPolygonCoords, event.coordinate ]).getExtent());
    this.asyncSelect(event, geometry)
      .finally(() => { this.isInProgress = false; });
  }

  get isInProgress () {
    return this.#isInProgress;
  }

  set isInProgress (isInProgress) {
    this.#isInProgress = isInProgress;
  }

  /**
   * Can be overridden in child classes.
   *
   * @protected
   * @param event - the DragBoxEvent event received on finishing the rectangle
   * @param geometry - the geometry created by the extent of all the points we clicked
   */
  asyncSelect (event, geometry) {

  }

}
